<template>
  <header :class="['header', $route.path === '/' ? 'header--home' : null]">
    <div class="container">
      <div class="header__left">
        <HistoryBack />
      </div>

      <div class="header__center">
        <Logo />
      </div>

      <div class="header__right">
        <span @click="() => installPrompt()">
          <Icon id="install-now" v-if="showInstaller === true" class="install-now"/>
        </span>
        <a href="https://www.heraklith.de/kontakt" target="_blank" aria-label="Kontakt">
          <Icon id="help-circle" />
        </a>
      </div>
    </div>
  </header>
</template>

<script>
import HistoryBack from '@/components/base/HistoryBack.vue';
import Logo from '@/components/base/Logo.vue';
import Icon from '@/components/Icon.vue';

export default {
  components: {
    HistoryBack,
    Logo,
    Icon,
  },
  mounted() {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      this.showInstaller = true;
      this.deferredPrompt = e;
    });
  },
  methods: {
    installPrompt() {
      if (this.deferredPrompt) {
        this.deferredPrompt.prompt();
        this.deferredPrompt.userChoice.then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            this.showInstaller = false;
          } else {
            this.showInstaller = true;
          }
        });
      }
    },
  },
  data() {
    return {
      deferredPrompt: null,
      showInstaller: false,
    };
  },
};
</script>

<style scoped lang="scss">
.header {
  background-color: $color-white;
  height: 60px;
  flex-shrink: 0; // Sticky footer (see: App.vue)
  animation: moveDown .4s ease-out;

  &--home {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    z-index: map-get($z-index, header);
  }

  &__left,
  &__center,
  &__right {
    display: flex;
  }

  &__left {
    flex-basis: 25%;
    justify-content: flex-start;
  }

  &__center {
    flex-basis: 75%;
    justify-content: center;
  }

  &__right {
    flex-basis: 25%;
    justify-content: flex-end;
    align-items: center;
  }

  .install-now {
    border: 2px solid $color-primary;
    border-radius: 100%;
    color: $color-primary;
    width: 3rem;
    height: 3rem;
    padding: 0.5rem;
    margin-bottom: 0.375rem;
    margin-right: 1rem;
    cursor: pointer;
  }

  .container {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
